import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import { Grid, IconButton, Menu, MenuItem } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { EventPattern } from '../../../types/eventPatterns'
import { useNavigate } from 'react-router-dom'

type Props = {
  eventPattern: EventPattern
  onRemoveClick: () => void
}

export default function TileMenuSection(props: Props) {
  const texts = useTranslation('eventPatternList').t
  const navigate = useNavigate()

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <Grid>
      <IconButton
        onClick={(event: React.MouseEvent<HTMLElement>) => {
          setAnchorEl(event.currentTarget)
        }}
        sx={{ color: '#000' }}
      >
        <MoreHorizIcon/>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          style: {
            width: '12rem',
          },
        }}
      >
        <MenuItem onClick={() => {
          navigate(`/schedule/event-patterns/${props.eventPattern.uuid}/edit`)
        }}>
          {texts('tile_menu_edit')}
        </MenuItem>
        <MenuItem onClick={() => {
          handleClose()
          props.onRemoveClick()
        }}>
          {texts('tile_menu_remove')}
        </MenuItem>
      </Menu>
    </Grid>
  )
}